// extracted by mini-css-extract-plugin
export default {"title":"xaa-z","warning":"yaa-z","sizeOptionsLegendText":"zaa-z"};